import { Grid, Typography, GridSize } from '@mui/material';
import { AddNewButton } from 'components';

interface IPageHeaderProps {
    pageTitle: any
    addNewUrl?: string
    subTitle?: string
    titleSmallGridSize?: boolean | GridSize | undefined
    buttonSmallGridSize?: boolean | GridSize | undefined
    titleGridSize?: boolean | GridSize | undefined
    buttonGridSize?: boolean | GridSize | undefined
    children?: JSX.Element
}

var PageHeader = ({ pageTitle, addNewUrl, subTitle, titleGridSize = true, buttonGridSize = false, titleSmallGridSize = true, buttonSmallGridSize = false, children }: IPageHeaderProps) => {
    return (
        <Grid container alignItems={children ? "stretch" : "flex-start"}>
            <Grid item xs={titleSmallGridSize} md={titleGridSize}>
                <Typography variant="h1">{pageTitle}</Typography>
                {subTitle && <Typography gutterBottom variant="h3">{subTitle}</Typography>}
            </Grid>

            {addNewUrl !== undefined &&
                <Grid item xs={buttonSmallGridSize} md={buttonGridSize}>
                    <AddNewButton link={addNewUrl} />
                </Grid>
            }

            {children && <>{children}</>}
        </Grid>
    );
}


export default PageHeader;